import { useHaicPageTitle } from '@h2oai/ui-kit';

import Header from '../../components/Header/Header';
import { useEnv } from '../../utils/hooks';
import Executions from './Executions';
import NavigationWrapper from './NavigationWrapper';

const ActiveExecutions = () => {
  const env = useEnv();

  useHaicPageTitle('Active Executions | Orchestrator', env?.cloudInstanceName);

  return (
    <NavigationWrapper>
      {/* TODO: Show/hide header. */}
      {/* {activeExecutionsItems?.length && !loading ? <Header /> : null} */}
      <Header customPageTitle="Active executions" />
      <Executions filterBy="running" />
    </NavigationWrapper>
  );
};

export default ActiveExecutions;
